import { useEffect } from "react"
import { Form, Row, Col, Button } from "react-bootstrap"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { getForSelect as getAnimalsForSelect } from '../../../actions/other/animalsActions'
import { getForSelect as getLotsForSelect } from '../../../actions/other/lotsActions'

export default function EventFormWeight({ type, state, handleInputChange, submit, isRegistering, isAddingOrEditing }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { animalsForSelect } = useSelector(state => state.animals)
	const { lotsForSelect } = useSelector(state => state.lots)

	useEffect(() => {
		dispatch(getAnimalsForSelect())
		dispatch(getLotsForSelect())
	}, [dispatch])

	const animals = animalsForSelect.map(a => ({ value: a._id, label: a.identifier, lot: a.lot }))
	const lots = lotsForSelect.map(l => ({ value: l._id, label: l.identifier }))

	const selectedLots = state.lots || []
	const selectedAnimalIds = state.animals || []

	const selectedAnimalObjs = animals.filter(a => selectedAnimalIds.includes(a.value))

	// ➕ Añadir animales de lotes seleccionados
	useEffect(() => {
		const relatedAnimals = animals
			.filter(a => selectedLots.includes(a.lot))
			.map(a => a.value)

		const allSelected = new Set([...(state.animals || []), ...relatedAnimals])

		handleInputChange({
			target: {
				name: 'animals',
				value: Array.from(allSelected)
			}
		})
	}, [state.lots])

	const handleAnimalSelect = (selectedOptions) => {
		const selectedIds = selectedOptions.map(opt => opt.value)
		const newWeights = { ...(state.weights || {}) }

		Object.keys(newWeights).forEach(id => {
			if (!selectedIds.includes(id)) delete newWeights[id]
		})

		handleInputChange({
			target: { name: 'animals', value: selectedIds }
		})
		handleInputChange({
			target: { name: 'weights', value: newWeights }
		})
	}

	const handleWeightChange = (animalId, value) => {
		const updated = {
			...(state.weights || {}),
			[animalId]: parseFloat(value)
		}
		handleInputChange({ target: { name: 'weights', value: updated } })
	}

	return (
		<Form onSubmit={submit} className="formulario">
			<h1 className="mb-4">{t('menus.event_weight')}</h1>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.animals')}</Form.Label>
						<Select
							isMulti
							options={animals}
							value={selectedAnimalObjs}
							onChange={handleAnimalSelect}
							isClearable
						/>
					</Form.Group>
				</Col>

				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.lots')}</Form.Label>
						<Select
							isMulti
							options={lots}
							value={lots.filter(opt => selectedLots.includes(opt.value))}
							onChange={(opts) => {
								handleInputChange({
									target: {
										name: 'lots',
										value: opts ? opts.map(o => o.value) : []
									}
								})
							}}
							isClearable
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.weightDate')}</Form.Label>
						<Form.Control
							type="date"
							name="weightDate"
							value={state.weightDate || ''}
							onChange={handleInputChange}
							required
						/>
					</Form.Group>
				</Col>
			</Row>

			{selectedAnimalObjs.length > 0 && (
				<>
					<Row className="my-2">
						<Col md={6}><h5>{t('admin.animal.animal')}</h5></Col>
						<Col md={6}><h5>{t('admin.animal.weight')} (kg)</h5></Col>
					</Row>
					{selectedAnimalObjs.map(animal => (
						<Row key={animal.value} className="my-2">
							<Col md={6}><Form.Label>{animal.label}</Form.Label></Col>
							<Col md={6}>
								<Form.Control
									type="number"
									min={0}
									step="0.01"
									value={state.weights?.[animal.value] || ''}
									onChange={(e) => handleWeightChange(animal.value, e.target.value)}
								/>
							</Col>
						</Row>
					))}
				</>
			)}

			<Row className="mt-4">
				<Col>
					<Button type="submit" className="w-100" variant="primary">
						{isRegistering
							? <span className="spinner-border spinner-border-sm" />
							: isAddingOrEditing === 'editing'
								? t('admin.animal.edit')
								: t('admin.animal.register')
						}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
